import { render, staticRenderFns } from "./rec_crmnl_hstry.vue?vue&type=template&id=0dbcd2b8&scoped=true&"
import script from "./rec_crmnl_hstry.vue?vue&type=script&lang=js&"
export * from "./rec_crmnl_hstry.vue?vue&type=script&lang=js&"
import style0 from "./rec_crmnl_hstry.vue?vue&type=style&index=0&id=0dbcd2b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbcd2b8",
  null
  
)

export default component.exports